// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7c58f305","453":"7063fd15","732":"143e3f38","977":"a4215216"}[chunkId] + ".chunk.js";
};